<div class="input-group mb-3">
  <span class="input-group-text" id="inputGroup-sizing-default">Motivo</span>
<select class="form-select" aria-label="Select Motivo" [(ngModel)]="motivo">
  <option *ngFor="let m of motivos" value={{m.motivo}}>{{m.motivo}}</option>
</select>
</div>
<div class="d-grid gap-2 d-md-flex justify-content-md-end">

  <button class="btn btn-primary" type="button" (click)="enviar()" [mat-dialog-close]="motivo">Cargar</button>
</div>
